module.exports = __webpack_public_path__ + "img/SKIDOO.b7dbd6c.jpg";